angular.module('festzelt-os.modules.merge-tags', [

]);

require('./components/al-merge-tags-selector/component');



// WEBPACK FOOTER //
// ./src/app/modules/merge-tags/module.js